import CustomButtonNew from 'Common/CustomButtonNew/CustomButtonNew'
import CustomDraggable from 'Common/CustomDraggable/CustomDraggable'
import FullPageLoader from 'Components/FullPageLoader/FullPageLoader'
import ReactPortal from 'Components/ReactPortal/ReactPortal'
import useDebounce from 'CustomHooks/useDebounce'
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage'
import api from 'http'
import React, { useEffect, useState } from 'react'

const CreateNewClaimPopup = ({ onClose, handleAddNew, disableDraggable }) => {
    const uniqueId = "CreateNewClaimPopup"
    const [inputValue, setInputValue] = useState("")
    const [patientsList, setPatientsList] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const debouncedSearchTerm = useDebounce(inputValue, 500);

    useEffect(() => {

        if (debouncedSearchTerm.length >= 2) {
            (async () => {
                try {
                    setIsLoading(true)
                    const response = await api.get(`${process.env.REACT_APP_TC_PMS}/api/Patient/PatientSuperSearch/${debouncedSearchTerm}`);
                    setIsLoading(false)
                    setPatientsList(response.data.dataModel.data)

                } catch (error) {
                    setIsLoading(false)
                    ErrorHandlingMessage(error)
                    setPatientsList([])
                }
            })();
        }
        else {
            setPatientsList([])
        }
    }, [debouncedSearchTerm])
    const genders = {
        M: 'Male',
        'F': 'Female'
    }
    return (
        <ReactPortal wrapperId={uniqueId}>
            {isLoading && <FullPageLoader allowFullScreen={true} />}
            <div
                data-te-modal-init
                className="fixed inset-0 z-10 flex items-center justify-center bg-gray-500 bg-opacity-75"
                id="exampleModalScrollable"
                tabIndex={-1}
                aria-labelledby="exampleModalScrollableLabel"
                aria-modal="true"
                data-te-open="true"
            >
                <CustomDraggable disableDraggable={disableDraggable} handle={`#${uniqueId}`}>
                    <div
                        data-te-modal-dialog-ref
                        className="relative w-[1140px] min-[576px]:mx-auto min-[576px]:mt-2 min-[576px]:max-w-[500px] min-[992px]:max-w-[800px] min-[1200px]:max-w-[1140px] flex flex-col overflow-hidden rounded-md bg-white shadow-lg"
                    >
                        {/* Header */}
                        <div
                            id={uniqueId}
                            className="flex items-center justify-between p-5 text-2xl font-semibold border-b cursor-grab"
                        >
                            Select New Patient
                        </div>
                        <div className="grid grid-cols-12 p-5">
                            <h3 className="text-lg font-medium text-gray-900 flex items-center col-span-9 px-2">Patients List</h3>
                            <div className='relative flex items-center col-span-3 px-2'>

                                <img src="/img/search.svg" alt="cross" className='absolute w-6 pl-1 left-3' />
                                <input value={inputValue} onChange={(e) => setInputValue(e.target.value.replace(/^\s+/, ''))} placeholder='Search...' className='w-full px-2 py-2 bg-[#E3E3E3] rounded-md outline-none pl-[28px]' type="search" />
                            </div>
                        </div>
                        <div className="overflow-y-auto max-h-[70vh]">
                            <div className="grid grid-cols-12">
                                <div className='col-span-12 '>
                                    <div className="flex flex-col">
                                        <div className="overflow-x-auto ">
                                            <div className="inline-block min-w-full py-2 ">
                                                <div className="overflow-hidden">
                                                    <table className="min-w-full text-sm font-light text-left">
                                                        <thead className="font-medium  bg-[#F5F5F5] text-[#3B3B3B]">
                                                            <tr>
                                                                <th scope="col" className="px-7 py-4 ">Patient</th>
                                                                <th scope="col" className="px-7 py-4 ">DOB</th>
                                                                <th scope="col" className="px-7 py-4 ">Gender</th>
                                                                <th scope="col" className="px-7 py-4 ">Account</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {patientsList.map((pat) => {
                                                                return (
                                                                    <tr key={pat.id} className="border-b dark:border-neutral-500">
                                                                        <td className="px-7 py-4 font-medium whitespace-nowrap">
                                                                            <span onClick={() => handleAddNew(pat)} className='font-semibold cursor-pointer hover:text-primary hover:underline'>   {pat.name}</span>

                                                                        </td>
                                                                        <td className="px-7 py-4 whitespace-nowrap">{pat.dob}</td>
                                                                        <td className="px-7 py-4 whitespace-nowrap">{genders[pat.gender] || 'Unknown'}</td>
                                                                        <td className="px-7 py-4 whitespace-nowrap">{pat.accountNum}</td>
                                                                    </tr>
                                                                )
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>

                        {/* Footer */}
                        <div className="flex flex-wrap items-center justify-end gap-2 p-5 ">
                            <CustomButtonNew label="Cancel" variant="outline" onClick={onClose} />
                        </div>
                    </div>
                </CustomDraggable>
            </div>
        </ReactPortal>
    )
}

export default CreateNewClaimPopup
